// extracted by mini-css-extract-plugin
export default {"bannerBottom":"HomeSecond_bannerBottom__d8xSm","imageBannerBottom":"HomeSecond_imageBannerBottom__jwwLs"};